import { render } from "./QuestionDetails.vue?vue&type=template&id=fe12a612&scoped=true"
import script from "./QuestionDetails.vue?vue&type=script&lang=js"
export * from "./QuestionDetails.vue?vue&type=script&lang=js"

import "./QuestionDetails.vue?vue&type=style&index=0&id=fe12a612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe12a612"]])

export default __exports__